<div class="card-header bg-light">
    <h4 class="card-title mb-0">
        <i class="far fa-file"></i> Adicionar Folha Teste
    </h4>
</div>
<form class="needs-validation" novalidate id="myForm" #f="ngForm">
    <div class="card-body">
        <div class="p-2 wrapper">
            <div class="row mb-2">
                <div class="col-md-2 mb-2">
                    <label class="form-label">Nº Folha Teste</label>
                    <input type="text" class="form-control form-control-sm" disabled placeholder="-"
                        [ngModel]="model.numeroFolha" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="col-md-10 mb-2">
                    <label class="form-label">Identificação Item Amostra</label>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="model.amostraItemDescricao"
                        name="amostraItemDescricao" maxlength="255" />
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-flex w-100 justify-content-between align-items-center">
            <div class="list1">
                <button class="btn btn-primary btn-sm mr-1" (click)="salvar()">
                    <i class="far fa-save"></i> Salvar
                </button>
                <button type="button" class="btn btn-default btn-sm mr-1" (click)="fechar()">
                    <i class="fas fa-times"></i> Cancelar
                </button>
            </div>
        </div>
    </div>
</form>